var _g, _rect, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 71,
    viewBox: "0 0 48 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5580_1453)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 40,
    height: 63,
    rx: 10,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5580_1453",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 26,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "matrix(-1 0 0 1 32 26)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5580_1453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2333 40.0667C27.3999 39.9 27.4833 39.7028 27.4833 39.475C27.4833 39.2472 27.3999 39.05 27.2333 38.8833L22.3499 34L27.2499 29.1C27.4055 28.9444 27.4833 28.75 27.4833 28.5167C27.4833 28.2833 27.3999 28.0833 27.2333 27.9167C27.0666 27.75 26.8694 27.6667 26.6416 27.6667C26.4138 27.6667 26.2166 27.75 26.0499 27.9167L20.4499 33.5333C20.3833 33.6 20.3361 33.6722 20.3083 33.75C20.2805 33.8278 20.2666 33.9111 20.2666 34C20.2666 34.0889 20.2805 34.1722 20.3083 34.25C20.3361 34.3278 20.3833 34.4 20.4499 34.4667L26.0666 40.0833C26.2222 40.2389 26.4138 40.3167 26.6416 40.3167C26.8694 40.3167 27.0666 40.2333 27.2333 40.0667Z",
    fill: "#434343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5580_1453",
    x: 0,
    y: 0,
    width: 48,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5580_1453"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5580_1453",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.017d6df2c9f3cf36a258d8ffd532dc56.svg";
export { ForwardRef as ReactComponent };